import { Response } from '@marketplace-web/shared/api-client'
import { CountriesResp } from 'types/api/response/countries-resp'
import { CountryModel } from 'types/models/country'
import { transformCountryDto } from 'data/transformers/country'

export const transformCountryResponse = (response: Response<CountriesResp>): Array<CountryModel> =>
  response.countries.map(transformCountryDto)
